import { getWishlistStorage } from '@jsmdg/browser-storage';
export var clearWishlist = function () {
    var wishlistStorage = getWishlistStorage();
    wishlistStorage.clear();
};
//# sourceMappingURL=clearWishlist.js.map